export default "__VITE_ASSET__gcjpy1Qt__"